// extracted by mini-css-extract-plugin
module.exports = {"settingsCard":"SettingsCard_settingsCard__1BvTl","content":"SettingsCard_content__M0kUj","title":"SettingsCard_title__3YXgK","description":"SettingsCard_description__2H_Gs"};